/**
 * Page State Manager
 * Dynamically manages page-specific CSS classes for adaptive UI
 */

let lastScrollY = 0
let ticking = false

export function initPageStateManager() {
  // Set data-page attribute on body for CSS targeting
  updatePageState()
  
  // Update on navigation (for SPA routing)
  window.addEventListener('popstate', updatePageState)
  
  // Listen for route changes (wouter-preact)
  const observer = new MutationObserver(updatePageState)
  observer.observe(document.body, { childList: true, subtree: true })
  
  // Scroll-based header compression
  window.addEventListener('scroll', onScroll, { passive: true })
}

function onScroll() {
  lastScrollY = window.scrollY
  
  if (!ticking) {
    window.requestAnimationFrame(() => {
      updateScrollState()
      ticking = false
    })
    ticking = true
  }
}

function updateScrollState() {
  const body = document.body
  const scrollThreshold = 80 // Pixels before header compresses
  
  if (lastScrollY > scrollThreshold) {
    body.classList.add('scrolled')
  } else {
    body.classList.remove('scrolled')
  }
}

export function updatePageState() {
  const path = window.location.pathname
  const body = document.body
  
  // Remove all page states
  body.removeAttribute('data-page')
  
  // Set page-specific state
  if (path === '/' || path === '/explorer') {
    body.setAttribute('data-page', 'explorer')
    setHeaderMode('compact')
  } else if (path.startsWith('/compare')) {
    body.setAttribute('data-page', 'compare')
    setHeaderMode('compare')
  } else {
    body.setAttribute('data-page', 'cell-detail')
    setHeaderMode('full')
  }
}

function setHeaderMode(mode) {
  const drawerHeader = document.querySelector('.drawer-header')
  const cmdbar = document.querySelector('.cmdbar')
  
  if (drawerHeader) {
    drawerHeader.classList.remove('compact', 'full', 'compare')
    drawerHeader.classList.add(mode)
  }
  
  if (cmdbar && mode === 'cell-detail') {
    cmdbar.classList.add('with-cell-info')
  } else if (cmdbar) {
    cmdbar.classList.remove('with-cell-info')
  }
}

// Export for manual triggering
export function setPageMode(mode) {
  document.body.setAttribute('data-page', mode)
  setHeaderMode(mode === 'explorer' ? 'compact' : mode === 'compare' ? 'compare' : 'full')
}
